/**
 * Diretiva responsável por criar um componente para a paginação de resultados de busca. 
 */

angular.module("avlib").directive("avPaginator", function(){
	return {
		template: require("!html-loader!./PaginatorTemplate.html"),
		restrict: "E",
		scope: {
			// Abaixo segue protótipo esperado como modelo de dados:
			//	pagination = {
			//		currentPage: 0,
			//		pageSize: 20,
			//		pageCount: 0,
			//		itemCount: 0,
			//	};
			ngModel: '=',
		},
		controller: "paginatorController",
	};
});
